(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[357],{

/***/ 30771:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/success-stories/[slug]",
      function () {
        return __webpack_require__(50429);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layout_Cta; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-light-svg-icons/index.mjs
var pro_light_svg_icons = __webpack_require__(38914);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ./components/marketingSite/shared/Cta.styled.tsx
var Cta_styled = __webpack_require__(7425);
// EXTERNAL MODULE: ./components/shared/ButtonLink.styled.tsx
var ButtonLink_styled = __webpack_require__(8536);
// EXTERNAL MODULE: ./components/shared/Typography.js
var Typography = __webpack_require__(99655);
// EXTERNAL MODULE: ./context/logged-user/loggeduser.context.tsx
var loggeduser_context = __webpack_require__(23357);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./hooks/useMediaQuery/useMediaQuery.tsx

var useMediaQuery = function(query) {
    var ref = (0,react.useState)(false), matches = ref[0], setMatches = ref[1];
    (0,react.useEffect)(function() {
        var media = window.matchMedia(query);
        if (media.matches !== matches) {
            setMatches(media.matches);
        }
        var listener = function() {
            return setMatches(media.matches);
        };
        media.addEventListener("change", listener);
        return function() {
            return media.removeEventListener("change", listener);
        };
    }, [
        matches,
        query
    ]);
    return matches;
};

;// CONCATENATED MODULE: ./hooks/useMediaQuery/index.ts


// EXTERNAL MODULE: ../../node_modules/next/dist/client/router.js
var router = __webpack_require__(93642);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./services/service.event-tracking.ts + 1 modules
var service_event_tracking = __webpack_require__(27862);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
;// CONCATENATED MODULE: ./components/marketingSite/successStories/layout/Cta.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        background-color: white;\n        color: ",
        ";\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #dcb4e8;\n  color: #52105e;\n\n  margin: ",
        ";\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n\n  width: 95%;\n  height: 100%;\n  object-fit: cover;\n  text-align: left;\n\n  mask-image: url('/images/common/irregular-box-white.svg');\n  mask-size: 100% 100%;\n  mask-repeat: no-repeat;\n  mask-position: center;\n\n  -webkit-mask-image: url('/images/common/irregular-box-white.svg');\n  -webkit-mask-size: 100% 100%;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n\n  @media (max-width: ",
        ") {\n    padding: ",
        ";\n\n    ",
        "\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: max-content;\n  white-space: nowrap;\n  flex: 0 0 auto;\n  margin-top: 0;\n  display: inline-flex;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: left;\n  max-width: ",
        ";\n  margin-top: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
















var StyledCtaBorder = (0,styled_components_browser_esm/* default */.ZP)(Cta_styled/* StyledCta */.B).withConfig({
    componentId: "sc-778e321e-0"
})(_templateObject1(), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl"), function(param) {
    var $alt = param.$alt;
    return !$alt && (0,styled_components_browser_esm/* css */.iv)(_templateObject(), (0,theme/* color */.$_)("midnight_700"));
});
var StyledButtonLink = (0,styled_components_browser_esm/* default */.ZP)(ButtonLink_styled/* default */.C).withConfig({
    componentId: "sc-778e321e-1"
})(_templateObject2());
var StyledActionsBorder = (0,styled_components_browser_esm/* default */.ZP)(Cta_styled/* StyledActions */.V).withConfig({
    componentId: "sc-778e321e-2"
})(_templateObject3(), (0,theme/* container */.nC)("xs"), (0,theme/* spacing */.W0)("md"));
var Cta = function(param) {
    var _alt = param.alt, alt = _alt === void 0 ? false : _alt;
    var t = (0,useI18n/* useI18n */.Q)("success-stories").t;
    var locale = (0,router.useRouter)().locale;
    var ref = (0,react.useContext)(loggeduser_context/* LoggedUserContext */.Vi), user = ref.user, loadingUser = ref.loadingUser;
    var isMobile = useMediaQuery("(max-width: 672px)");
    var commonButtonProps = {
        variant: "blogCompany",
        sizes: "md",
        onClick: function(e) {
            return service_event_tracking/* default.trackExternalLandingCtaClicked */.Z.trackExternalLandingCtaClicked(e, "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.hrAsAService */.uu.hrAsAService)), "footer-success-stories");
        }
    };
    if (user || loadingUser) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCtaBorder, {
        $alt: alt,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading3 */.aC, {
                children: t("cta.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: t("cta.desc")
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledActionsBorder, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.hrAsAService */.uu.hrAsAService)),
                    passHref: true,
                    children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonLink, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonButtonProps), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: t("cta.action-small")
                        })
                    })) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledButtonLink, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonButtonProps), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("cta.action")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: pro_light_svg_icons/* faArrowRight */.eFW
                            })
                        ]
                    }))
                })
            })
        ]
    });
};
/* harmony default export */ var layout_Cta = (Cta);


/***/ }),

/***/ 66404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Em": function() { return /* binding */ getPostCategoriesId; },
/* harmony export */   "Mj": function() { return /* binding */ getPostThumb; },
/* harmony export */   "iH": function() { return /* binding */ sortCategories; }
/* harmony export */ });
/* unused harmony export hiddenCategories */
function getPostThumb(post) {
    var ref;
    var embedded = (ref = post._embedded) === null || ref === void 0 ? void 0 : ref["wp:featuredmedia"];
    var media = embedded && embedded[0] ? embedded[0] : undefined;
    return media ? media.source_url : undefined;
}
var hiddenCategories = (/* unused pure expression or super */ null && ([
    "uncategorized",
    "uncategorised",
    "oculto",
    "sin-categorizar",
    "all",
    "todo-el-blog"
]));
function getPostCategoriesId(post, categories) {
    if (!post.categories || !categories) {
        return undefined;
    }
    return post.categories.map(function(catId) {
        var category = categories.find(function(c) {
            return c.id === catId;
        });
        return category ? category.name : "";
    }).filter(Boolean).sort(function(a, b) {
        return a.localeCompare(b);
    });
}
var sortCategories = function(categories) {
    var specialFirst = function(a, b) {
        if (a.id === 304) return -1;
        if (b.id === 304) return 1;
        return a.name.localeCompare(b.name);
    };
    return {
        parent: categories.filter(function(cat) {
            return cat.parent === 0;
        }).sort(specialFirst),
        children: categories.filter(function(cat) {
            return cat.parent !== 0;
        }).sort(function(a, b) {
            return a.name.localeCompare(b.name);
        })
    };
};


/***/ }),

/***/ 17975:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fo": function() { return /* binding */ StyledFormGroupContent; },
/* harmony export */   "OQ": function() { return /* binding */ StyledFormGroupField; },
/* harmony export */   "S0": function() { return /* binding */ StyledFormGroupLabelExtra; },
/* harmony export */   "Xq": function() { return /* binding */ StyledHelpIcon; },
/* harmony export */   "Z2": function() { return /* binding */ StyledFormGroupLabelWrapper; },
/* harmony export */   "Zm": function() { return /* binding */ StyledBottomAction; },
/* harmony export */   "dS": function() { return /* binding */ StyledFormGroup; },
/* harmony export */   "fI": function() { return /* binding */ StyledFormGroupSuccess; },
/* harmony export */   "jN": function() { return /* binding */ StyledFormGroupError; },
/* harmony export */   "kI": function() { return /* binding */ StyledFormGroupLabel; },
/* harmony export */   "nX": function() { return /* binding */ StyledFormGroupSpinnerSlot; },
/* harmony export */   "qB": function() { return /* binding */ StyledHint; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var components_shared_Select_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34956);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40286);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  font-size: ",
        ";\n  margin-bottom: ",
        ";\n\n  position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  bottom: -",
        ";\n  left: 0;\n  z-index: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      display: flex;\n      align-items: center;\n      gap: ",
        ";\n\n      ",
        " {\n        margin-bottom: 0;\n        margin-right: ",
        ";\n      }\n\n      ",
        " {\n        margin-top: 0;\n      }\n\n      input {\n        flex-grow: 1;\n        width: auto;\n      }\n\n      ",
        " {\n        display: flex;\n        align-items: center;\n        padding-top: ",
        ";\n        padding-bottom: ",
        ";\n      }\n\n      ",
        " {\n        width: auto;\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  width: 100%;\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: ",
        ";\n\n  &.muted {\n    font-weight: ",
        ";\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      display: flex;\n      gap: ",
        ";\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-image: url(\"data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' %3E%3Cpath d='M8 10.7097C7.50116 10.7097 7.09677 11.1141 7.09677 11.6129C7.09677 12.1117 7.50116 12.5161 8 12.5161C8.49884 12.5161 8.90323 12.1117 8.90323 11.6129C8.90323 11.1141 8.49884 10.7097 8 10.7097ZM8.24742 9.93548H7.73129C7.51752 9.93548 7.34419 9.76216 7.34419 9.54839V9.5361C7.34419 7.26697 9.84226 7.48387 9.84226 6.07132C9.84226 5.42564 9.26932 4.77419 7.98935 4.77419C7.04923 4.77419 6.56145 5.08545 6.07932 5.69974C5.95326 5.86039 5.72274 5.89313 5.55519 5.77639L5.13152 5.48123C4.95006 5.35481 4.91023 5.10152 5.04619 4.92713C5.7309 4.04884 6.54329 3.48387 7.98935 3.48387C9.6771 3.48387 11.1326 4.44358 11.1326 6.07132C11.1326 8.24597 8.63452 8.13097 8.63452 9.5361V9.54839C8.63452 9.76216 8.46119 9.93548 8.24742 9.93548ZM8 1.03226C11.8265 1.03226 14.9677 4.13145 14.9677 8C14.9677 11.8481 11.8513 14.9677 8 14.9677C4.15342 14.9677 1.03226 11.8528 1.03226 8C1.03226 4.15474 4.14845 1.03226 8 1.03226ZM8 0C3.58203 0 0 3.58332 0 8C0 12.4193 3.58203 16 8 16C12.418 16 16 12.4193 16 8C16 3.58332 12.418 0 8 0Z' fill='%2330ABD5' /%3E%3C/svg%3E\");\n  height: ",
        ";\n  width: ",
        ";\n  display: inline-block;\n  margin: 0 ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-left: ",
        ";\n  color: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  display: flex;\n  margin-top: ",
        ";\n  font-size: ",
        ";\n  justify-content: flex-start;\n\n  svg {\n    width: ",
        ";\n    height: ",
        ";\n    margin-right: ",
        ";\n    margin-top: 2px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  display: flex;\n  margin-top: ",
        ";\n  font-size: ",
        ";\n\n  svg {\n    width: ",
        ";\n    height: ",
        ";\n    margin-right: ",
        ";\n    margin-top: 2px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}



var StyledFormGroupLabelWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-5dc5d8fe-0"
})(_templateObject(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xs"));
var StyledFormGroupSpinnerSlot = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5dc5d8fe-1"
})(_templateObject1(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .zindex */ .Y0)("spinnerSlot"));
var StyledBottomAction = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5dc5d8fe-2"
})(_templateObject2(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"));
var StyledHint = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5dc5d8fe-3"
})(_templateObject3(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("xs"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("text_subtle"));
var StyledFormGroup = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5dc5d8fe-4"
})(_templateObject5(), function(param) {
    var inline = param.inline;
    return inline && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject4(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xs"), StyledFormGroupLabelWrapper, (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xs"), StyledBottomAction, StyledFormGroupContent, (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"), components_shared_Select_styled__WEBPACK_IMPORTED_MODULE_1__/* .StyledSelect */ .Q);
});
var StyledFormGroupLabel = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].label.withConfig */ .ZP.label.withConfig({
    componentId: "sc-5dc5d8fe-5"
})(_templateObject6(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontWeight */ .Ue)("black"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontWeight */ .Ue)("medium"));
var StyledFormGroupField = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5dc5d8fe-6"
})(_templateObject8(), function(param) {
    var withAppend = param.withAppend;
    return withAppend && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject7(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"));
});
var StyledFormGroupContent = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5dc5d8fe-7"
})(_templateObject9());
var StyledHelpIcon = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-5dc5d8fe-8"
})(_templateObject10(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xs"));
var StyledFormGroupLabelExtra = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].label.withConfig */ .ZP.label.withConfig({
    componentId: "sc-5dc5d8fe-9"
})(_templateObject11(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xs"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("midnight_500"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontWeight */ .Ue)("medium"));
var StyledFormGroupError = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-5dc5d8fe-10"
})(_templateObject12(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xs"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xs2"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("negative_500"));
var StyledFormGroupSuccess = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-5dc5d8fe-11"
})(_templateObject13(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xs"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xs2"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("positive_500"));


/***/ }),

/***/ 74993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9725);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49929);
/* harmony import */ var hooks_useI18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39105);
/* harmony import */ var _FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17975);
/* harmony import */ var _HelpTooltip_HelpTooltip__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73091);






var FormGroup = function(param) {
    var label = param.label, children = param.children, error = param.error, forId = param.forId, className = param.className, labelExtra = param.labelExtra, bottomAction = param.bottomAction, _isLabelMuted = param.isLabelMuted, isLabelMuted = _isLabelMuted === void 0 ? false : _isLabelMuted, _inline = param.inline, inline = _inline === void 0 ? false : _inline, style = param.style, success = param.success, helpContent = param.helpContent, _isLabelHidden = param.isLabelHidden, isLabelHidden = _isLabelHidden === void 0 ? false : _isLabelHidden, hint = param.hint, append = param.append, spinnerSlot = param.spinnerSlot;
    var t = (0,hooks_useI18n__WEBPACK_IMPORTED_MODULE_2__/* .useI18n */ .Q)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFormGroup */ .dS, {
        className: className,
        style: style,
        inline: inline,
        children: [
            (label || labelExtra) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFormGroupLabelWrapper */ .Z2, {
                className: "".concat(isLabelHidden ? "sr-only" : ""),
                children: [
                    label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFormGroupLabel */ .kI, {
                        htmlFor: forId,
                        className: "".concat(isLabelMuted ? "muted" : "", " ").concat(isLabelHidden ? "sr-only" : ""),
                        children: label
                    }),
                    helpContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HelpTooltip_HelpTooltip__WEBPACK_IMPORTED_MODULE_4__/* .HelpTooltip */ .k, {
                        message: helpContent
                    }),
                    labelExtra && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFormGroupLabelExtra */ .S0, {
                        children: labelExtra
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFormGroupField */ .OQ, {
                withAppend: !!append,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFormGroupContent */ .Fo, {
                        children: children
                    }),
                    append
                ]
            }),
            hint && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledHint */ .qB, {
                children: hint
            }),
            bottomAction && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledBottomAction */ .Zm, {
                children: bottomAction
            }),
            error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFormGroupError */ .jN, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                        icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_5__/* .faTimesCircle */ .nYk
                    }),
                    t(error)
                ]
            }),
            success && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFormGroupSuccess */ .fI, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                        icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_5__/* .faCheckCircle */ .f8k
                    }),
                    success
                ]
            }),
            spinnerSlot && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFormGroupSpinnerSlot */ .nX, {
                children: spinnerSlot
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FormGroup);


/***/ }),

/***/ 73091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ HelpTooltip; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _FormGroup_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17975);
/* harmony import */ var _TooltipMF__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83885);



var HelpTooltip = function(param) {
    var message = param.message;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TooltipMF__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        content: message,
        type: "full-content",
        direction: "up",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_1__/* .StyledHelpIcon */ .Xq, {})
    });
};


/***/ }),

/***/ 34956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ StyledSelect; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40286);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border-color: ",
        " !important;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: ",
        ";\n      font-size: ",
        ";\n      height: ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      opacity: 1;\n      pointer-events: none;\n      background-color: ",
        ";\n      border-color: ",
        ";\n      color: ",
        ";\n      background-image: url(\"data:image/svg+xml,%3Csvg width='8' height='6' viewBox='0 0 8 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.538289 0.730957H7.46171C7.94067 0.730957 8.18015 1.30948 7.84111 1.64852L4.38075 5.11158C4.17087 5.32146 3.82913 5.32146 3.61925 5.11158L0.158886 1.64852C-0.180154 1.30948 0.0593268 0.730957 0.538289 0.730957Z' fill='%23DEDCE4'/%3E%3C/svg%3E%0A\");\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  appearance: none;\n  min-width: ",
        ";\n  height: 3.5rem;\n  padding: 1rem 3.25rem 1rem 1.25rem;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n  border-radius: ",
        ";\n  border: 2px solid ",
        ";\n  transition: 0.3s;\n  background-image: url(\"data:image/svg+xml,%3Csvg width='8' height='6' viewBox='0 0 8 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.538289 0.730988H7.46171C7.94067 0.730988 8.18015 1.30951 7.84111 1.64855L4.38075 5.11161C4.17087 5.32149 3.82913 5.32149 3.61925 5.11161L0.158886 1.64855C-0.180154 1.30951 0.0593268 0.730988 0.538289 0.730988Z' fill='%23353241'/%3E%3C/svg%3E%0A\");\n  background-repeat: no-repeat;\n  background-position: right ",
        " top 50%;\n  background-size: 0.65em auto;\n  background-color: ",
        ";\n\n  ",
        "\n\n  ",
        "\n\n  &::-ms-expand {\n    display: none;\n  }\n\n  &:hover {\n    border-color: ",
        ";\n  }\n\n  &:focus {\n    outline: 0;\n    border-color: ",
        ";\n    box-shadow: 0 0 0 4px ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var roleVariants = {
    error: {
        borderColor: (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("negative_700")
    }
};
var sizeVariants = {
    sm: {
        padding: "0.25rem 0.75rem",
        fontSize: (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xs"),
        height: "2.5rem"
    }
};
var StyledSelect = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].select.withConfig */ .ZP.select.withConfig({
    componentId: "sc-8861b5b9-0"
})(_templateObject3(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl6"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("sans"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("medium"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text_default"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .radius */ .q0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_200"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("white"), function(param) {
    var variant = param.variant;
    return variant && roleVariants[variant] && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), roleVariants[variant].borderColor);
}, function(param) {
    var sizes = param.sizes;
    return sizes && sizeVariants[sizes] && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), sizeVariants[sizes].padding, sizeVariants[sizes].fontSize, sizeVariants[sizes].height);
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_400"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_850"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_150"), function(param) {
    var disabled = param.disabled;
    return disabled && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_150"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_200"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text_disabled"));
});


/***/ }),

/***/ 80087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E$": function() { return /* binding */ StyledCopyWrapper; },
/* harmony export */   "It": function() { return /* binding */ StyledShareModalButtons; },
/* harmony export */   "ao": function() { return /* binding */ StyledCopyAnchor; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40286);
/* harmony import */ var theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  margin-bottom: ",
        ";\n\n  > *:not(:last-child) {\n    margin-right: ",
        ";\n  }\n\n  @media (max-width: ",
        ") {\n    flex-wrap: wrap;\n    > * {\n      width: 2.5rem;\n      height: 2.5rem;\n\n      svg {\n        width: ",
        ";\n        height: ",
        ";\n      }\n\n      &:not(:last-child) {\n        margin-right: ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-block;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: flex-end;\n  flex-direction: column;\n  padding-right: 2rem;\n  line-height: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var StyledShareModalButtons = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-724ab933-0"
})(_templateObject(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("mdMax"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"));
var StyledCopyAnchor = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-724ab933-1"
})(_templateObject1());
var StyledCopyWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-724ab933-2"
})(_templateObject2());


/***/ }),

/***/ 50429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ./components/layout/Page.tsx + 19 modules
var Page = __webpack_require__(24882);
// EXTERNAL MODULE: ./context/logged-user/loggeduser.context.tsx
var loggeduser_context = __webpack_require__(23357);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ../../node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(86741);
// EXTERNAL MODULE: ../../node_modules/next/dist/client/router.js
var router = __webpack_require__(93642);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(9725);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-light-svg-icons/index.mjs
var pro_light_svg_icons = __webpack_require__(38914);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ./components/shared/Button.styled.tsx
var Button_styled = __webpack_require__(59760);
// EXTERNAL MODULE: ./components/shared/ButtonLink.styled.tsx
var ButtonLink_styled = __webpack_require__(8536);
// EXTERNAL MODULE: ./components/shared/Typography.styled.tsx
var Typography_styled = __webpack_require__(90637);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./services/service.event-tracking.ts + 1 modules
var service_event_tracking = __webpack_require__(27862);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./utils/paths.tsx
var paths = __webpack_require__(64516);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./components/marketingSite/successStories/layout/BlogFloatingCta.styled.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: 0;\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  padding: ",
        " ",
        " ",
        ";\n  color: ",
        ";\n  font-weight: ",
        ";\n  line-height: 1.25;\n  background-image: ",
        ";\n  background-size: contain;\n  background-position: center center;\n  background-repeat: no-repeat;\n\n  max-width: 400px;\n\n  &::before {\n    content: '';\n    width: 204px;\n    height: 173px;\n    position: absolute;\n    top: 0;\n    left: 50%;\n    transform: translate(-50%, -60%);\n    background-image: ",
        ";\n  }\n\n  ",
        " {\n    position: absolute;\n    top: ",
        ";\n    right: ",
        ";\n  }\n\n  ",
        " {\n    &::before {\n      left: 0;\n      transform: unset;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var StyledCta = styled_components_browser_esm/* default.aside.withConfig */.ZP.aside.withConfig({
    componentId: "sc-b03b8ddd-0"
})(_templateObject(), (0,theme/* color */.$_)("midnight_900"), (0,theme/* radius */.q0)("lg"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* color */.$_)("text_default_inverse"), (0,theme/* fontWeight */.Ue)("medium"), function() {
    return "url('".concat((0,paths/* getPublicPath */.A)("/images/successStories/floating-cta-bg.svg"), "')");
}, function() {
    return "url('".concat((0,paths/* getPublicPath */.A)("/images/successStories/floating-cta-image.svg"), "')");
}, Button_styled/* default */.Z, (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("xs"), Typography_styled/* Heading3 */.aC);

;// CONCATENATED MODULE: ./components/marketingSite/successStories/layout/BlogFloatingCta.tsx















var SESSION_HIDE_BLOG_FLOATING_CTA = "SESSION_HIDE_BLOG_FLOATING_CTA";
var BlogFloatingCta = function() {
    var closeBanner = function closeBanner() {
        var ref;
        setIsBannerClosed(true);
        window === null || window === void 0 ? void 0 : (ref = window.sessionStorage) === null || ref === void 0 ? void 0 : ref.setItem(SESSION_HIDE_BLOG_FLOATING_CTA, "true");
    };
    var t = (0,useI18n/* useI18n */.Q)("success-stories").t;
    var locale = (0,router.useRouter)().locale;
    var ref = (0,react.useContext)(loggeduser_context/* LoggedUserContext */.Vi), user = ref.user, loadingUser = ref.loadingUser;
    var ref1 = (0,react.useState)(false), isBannerClosed = ref1[0], setIsBannerClosed = ref1[1];
    (0,react.useEffect)(function() {
        var ref;
        setIsBannerClosed((window === null || window === void 0 ? void 0 : (ref = window.sessionStorage) === null || ref === void 0 ? void 0 : ref.getItem(SESSION_HIDE_BLOG_FLOATING_CTA)) === "true");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !isBannerClosed && !user && !loadingUser && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCta, {
            role: "complementary",
            "aria-live": "polite",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_styled/* default */.Z, {
                    variant: "tertiary",
                    sizes: "sm",
                    isIcon: true,
                    onClick: closeBanner,
                    "aria-label": t("floatingCTA.close"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: pro_light_svg_icons/* faTimes */.NBC
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_styled/* Heading3 */.aC, {
                    editorial: true,
                    as: "p",
                    children: t("floatingCTA.title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: t("floatingCTA.desc")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.join */.uu.join, locale), "?locale=").concat(locale, "&source=floating-blog"),
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink_styled/* default */.C, {
                        variant: "brandTalent",
                        sizes: "md",
                        onClick: function(e) {
                            return service_event_tracking/* default.trackExternalLandingCtaClicked */.Z.trackExternalLandingCtaClicked(e, "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.join */.uu.join, locale), "?locale=").concat(locale, "&source=floating-blog"), "floating-blog");
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: free_solid_svg_icons/* faCheckCircle */.f8k
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("floatingCTA.cta")
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var layout_BlogFloatingCta = (BlogFloatingCta);

// EXTERNAL MODULE: ./components/marketingSite/successStories/utils/blogUtils.ts
var blogUtils = __webpack_require__(66404);
// EXTERNAL MODULE: ./components/marketingSite/blog/cards/BlogCard.tsx + 1 modules
var BlogCard = __webpack_require__(12032);
;// CONCATENATED MODULE: ./components/marketingSite/successStories/post/RecommendedPosts.tsx

function RecommendedPosts_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: ",
        " auto;\n  max-width: ",
        ";\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"
    ]);
    RecommendedPosts_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: ",
        ";\n  width: 100%;\n\n  @media (min-width: ",
        ") {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  @media (min-width: ",
        ") {\n    grid-template-columns: repeat(3, 1fr);\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-492430ed-0"
})(RecommendedPosts_templateObject(), (0,theme/* spacing */.W0)("xl3"), (0,theme/* container */.nC)("xl"));
var StyledBlogCards = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-492430ed-1"
})(_templateObject1(), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("lg"));
var RecommendedPosts = function(param) {
    var relatedPosts = param.relatedPosts, currentPost = param.currentPost, categories = param.categories, locale = param.locale, tags = param.tags;
    var t = (0,useI18n/* useI18n */.Q)("success-stories").t;
    if (!relatedPosts.length) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: t("post.related")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBlogCards, {
                children: relatedPosts.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogCard/* default */.Z, {
                        post: item,
                        title: item.title.rendered,
                        url: item.slug,
                        thumb: (0,blogUtils/* getPostThumb */.Mj)(item),
                        date: item.date,
                        allTags: tags
                    }, item.slug);
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../ui-library/dist/index.js + 203 modules
var dist = __webpack_require__(78197);
// EXTERNAL MODULE: ./components/marketingSite/successStories/layout/Cta.tsx + 2 modules
var Cta = __webpack_require__(2635);
;// CONCATENATED MODULE: ./components/marketingSite/successStories/post/PostComponent.styled.tsx

function PostComponent_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  background-color: ",
        ";\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    PostComponent_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PostComponent_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 ",
        ";\n  font-size: ",
        ";\n  line-height: 1.6;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  p,\n  ul,\n  ol,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  img,\n  blockquote {\n    max-width: ",
        ";\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  img {\n    display: block;\n    margin-top: ",
        ";\n    margin-bottom: ",
        ";\n    border: ",
        " solid ",
        ";\n    border-radius: ",
        ";\n    width: 100%;\n  }\n\n  h2 {\n    font-family: ",
        ";\n    font-weight: ",
        ";\n    font-size: ",
        ";\n    line-height: 1.17;\n    margin-top: ",
        ";\n    margin-bottom: ",
        ";\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n    }\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n    }\n  }\n\n  h3 {\n    font-family: ",
        ";\n    font-weight: ",
        ";\n    font-size: ",
        ";\n    line-height: 1.12;\n    margin-top: ",
        ";\n    margin-bottom: ",
        ";\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n    }\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n    }\n  }\n\n  h4 {\n    font-family: ",
        ";\n    font-weight: ",
        ";\n    font-size: ",
        ";\n    line-height: 1.14;\n    margin-top: ",
        ";\n    margin-bottom: ",
        ";\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n    }\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n    }\n  }\n\n  h5 {\n    font-family: ",
        ";\n    font-weight: ",
        ";\n    font-size: ",
        ";\n    line-height: 1.14;\n    margin-top: ",
        ";\n    margin-bottom: ",
        ";\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n    }\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n    }\n  }\n\n  h6 {\n    font-family: ",
        ";\n    font-weight: ",
        ";\n    font-size: ",
        ";\n    line-height: 1.14;\n    margin-top: ",
        ";\n    margin-bottom: ",
        ";\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n    }\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n    }\n  }\n\n  ul {\n    list-style-type: disc;\n    padding-left: 1em;\n  }\n\n  ol {\n    padding-left: 1em;\n  }\n\n  li {\n    margin-top: ",
        ";\n    margin-bottom: ",
        ";\n    list-style: inherit;\n  }\n\n  table {\n    max-width: ",
        ";\n    font-size: ",
        ";\n    border-radius: ",
        ";\n    box-shadow: ",
        ";\n    white-space: normal;\n  }\n\n  tbody {\n    width: 100%;\n    display: table;\n  }\n\n  tr:nth-child(1n) {\n    background: ",
        ";\n  }\n\n  td {\n    padding: ",
        " ",
        ";\n    text-align: left;\n    white-space: normal;\n\n    &.has-text-align-center {\n      text-align: center;\n    }\n  }\n\n  .wp-block-table {\n    margin: ",
        " 0;\n    overflow-x: auto;\n    padding: ",
        " ",
        ";\n\n    table {\n      border-collapse: collapse;\n      width: 100%;\n    }\n\n    tr:nth-child(odd) {\n      background: ",
        ";\n    }\n  }\n\n  .wp-block-image,\n  .wp-caption {\n    max-width: ",
        ";\n    margin: ",
        " auto;\n    display: block;\n    background-color: ",
        ";\n    color: ",
        ";\n    font-size: ",
        ";\n\n    .size-medium {\n      max-width: ",
        ";\n    }\n\n    img {\n      border: 0;\n      margin: 0;\n      border-radius: 0;\n    }\n\n    figcaption {\n      text-align: left;\n      padding-top: ",
        ";\n    }\n\n    a {\n      color: ",
        ";\n\n      &:hover {\n        color: ",
        ";\n      }\n\n      &:active {\n        color: ",
        ";\n      }\n    }\n  }\n\n  .wp-block-group {\n    max-width: ",
        ";\n    margin: ",
        " auto;\n    display: block;\n\n    iframe {\n      border: 0;\n    }\n  }\n\n  .wp-block-video {\n    max-width: ",
        ";\n    margin: ",
        " auto;\n    border: ",
        " solid ",
        ";\n    border-radius: ",
        ";\n\n    video {\n      width: 100%;\n    }\n  }\n\n  .wp-block-embed-youtube {\n    max-width: ",
        ";\n    margin: ",
        " auto;\n    border: ",
        " solid ",
        ";\n    border-radius: ",
        ";\n\n    .wp-block-embed__wrapper {\n      position: relative;\n      padding-bottom: 56.25%;\n      height: 0;\n      overflow: hidden;\n      max-width: 100%;\n    }\n\n    iframe {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n    }\n  }\n\n  .wp-block-embed-arcade {\n    max-width: ",
        ";\n    margin: ",
        " auto;\n    border: ",
        " solid ",
        ";\n    border-radius: ",
        ";\n    background-color: ",
        ";\n\n    .wp-block-embed__wrapper {\n      position: relative;\n      padding-bottom: 52.75%;\n      height: 0;\n      overflow: hidden;\n      max-width: 100%;\n      background-color: ",
        ";\n\n      @media (max-width: ",
        ") {\n        padding-bottom: 62%;\n      }\n    }\n\n    iframe {\n      border: 0;\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n    }\n  }\n\n  .wp-block-spacer {\n    display: none;\n  }\n\n  .has-inline-color {\n    color: inherit !important;\n  }\n\n  *[style*='color'] {\n    color: inherit !important;\n  }\n\n  .wp-block-quote,\n  .twitter-tweet {\n    margin-top: ",
        ";\n    margin-bottom: ",
        ";\n    padding-left: ",
        ";\n    border-left: ",
        " solid ",
        ";\n  }\n\n  .instagram-media {\n    margin: ",
        " auto !important;\n  }\n\n  .wp-block-buttons {\n    &.is-layout-flex {\n      display: flex;\n      align-items: center;\n    }\n    &.is-content-justification-center {\n      justify-content: center;\n    }\n  }\n\n  .wp-block-button {\n    margin-top: ",
        ";\n\n    &__link {\n      background-color: ",
        " !important;\n      color: ",
        " !important;\n      font-size: ",
        " !important;\n      text-transform: uppercase !important;\n      font-weight: ",
        " !important;\n      padding: ",
        " ",
        " !important;\n      border-radius: ",
        " !important;\n      transition: 0.3s !important;\n      display: inline-block;\n      text-align: center;\n\n      &:hover,\n      &:active {\n        background-color: ",
        " !important;\n      }\n\n      &:focus {\n        outline: 0;\n        box-shadow: 0 0 0 4px ",
        ";\n        color: ",
        " !important;\n      }\n    }\n  }\n"
    ]);
    PostComponent_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: ",
        " auto;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: ",
        " auto;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 20.5rem;\n  position: sticky;\n  left: calc(50% + ",
        " / 2 + ",
        ");\n  bottom: ",
        ";\n  margin-bottom: ",
        ";\n  margin-right: ",
        ";\n\n  @media (max-width: ",
        ") {\n    display: none;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  gap: ",
        ";\n  max-width: ",
        ";\n  margin: auto;\n  width: 100%;\n  padding: ",
        " ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  padding: 0 ",
        ";\n\n  @media (min-width: ",
        ") {\n    max-width: ",
        ";\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n\n  @media (min-width: ",
        ") {\n    display: block;\n\n    flex: 0 0 ",
        ";\n    max-width: ",
        ";\n\n    margin-left: calc((",
        " + ",
        ") * -1);\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: sticky;\n  z-index: 1;\n  top: calc(var(--header-offset, 0px) + 1rem);\n  transition: top 0.3s ease-in-out;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: ",
        " auto ",
        " auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n  align-items: center;\n  justify-content: center;\n  position: fixed;\n  bottom: ",
        ";\n  left: ",
        ";\n  width: 48px;\n  height: 48px;\n  border: none;\n  border-radius: ",
        ";\n\n  font-size: 1.25rem;\n  cursor: pointer;\n\n  & > span > svg {\n    color: white;\n  }\n\n  @media (min-width: ",
        ") {\n    display: none;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      transform: translateX(0);\n    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 80vw;\n  max-width: 300px;\n  background: white;\n  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.2);\n  padding: ",
        ";\n  z-index: 4;\n\n  transform: translateX(-100%);\n  transition: transform 0.3s ease;\n\n  ",
        "\n\n  @media (min-width: ",
        ") {\n    display: none;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: ",
        ";\n  right: ",
        ";\n  border: none;\n  background: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n  overflow-y: auto;\n  max-height: calc(100vh - ",
        ");\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.3);\n  z-index: 2;\n  display: flex;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #dcb4e8 !important;\n  color: #52105e !important;\n  @media (max-width: ",
        ") {\n    background-color: #dcb4e8 !important;\n    color: #52105e !important;\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}





var StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3c1aca9a-0"
})(PostComponent_styled_templateObject(), (0,theme/* color */.$_)("midnight_100"));
var StyledPostContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3c1aca9a-1"
})(PostComponent_styled_templateObject1(), (0,theme/* spacing */.W0)("md"), (0,theme/* fontSize */.JB)("md"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* container */.nC)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("text_default"), (0,theme/* radius */.q0)("md"), (0,theme/* fontFamily */.I8)("serif"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* fontSize */.JB)("xl2"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl3"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("xl4"), (0,theme/* fontFamily */.I8)("serif"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* fontSize */.JB)("xl"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl2"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("xl3"), (0,theme/* fontFamily */.I8)("serif"), (0,theme/* fontWeight */.Ue)("bold"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("xl2"), (0,theme/* fontFamily */.I8)("serif"), (0,theme/* fontWeight */.Ue)("bold"), (0,theme/* fontSize */.JB)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("xl"), (0,theme/* fontFamily */.I8)("serif"), (0,theme/* fontWeight */.Ue)("bold"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("sm"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("md"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* container */.nC)("xl"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* radius */.q0)("md"), (0,theme/* shadow */.AF)("md"), (0,theme/* color */.$_)("white"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xs"), (0,theme/* color */.$_)("midnight_100"), (0,theme/* container */.nC)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* color */.$_)("text_default"), (0,theme/* color */.$_)("text_default_inverse"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* container */.nC)("sm"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("link_inverse"), (0,theme/* color */.$_)("link_inverse_hover"), (0,theme/* color */.$_)("link_inverse_active"), (0,theme/* container */.nC)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* container */.nC)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("text_default"), (0,theme/* radius */.q0)("md"), (0,theme/* container */.nC)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("text_default"), (0,theme/* radius */.q0)("md"), (0,theme/* container */.nC)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("text_default"), (0,theme/* radius */.q0)("md"), (0,theme/* color */.$_)("text_default"), (0,theme/* color */.$_)("text_default"), (0,theme/* screen */.sp)("mdMax"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* color */.$_)("emerald_400"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* color */.$_)("emerald_600"), (0,theme/* color */.$_)("white"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("lg"), (0,theme/* radius */.q0)("md"), (0,theme/* color */.$_)("emerald_400"), (0,theme/* color */.$_)("midnight_150"), (0,theme/* color */.$_)("midnight_150"));
var StyledRecommendations = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-3c1aca9a-2"
})(_templateObject2(), (0,theme/* container */.nC)("xl"), (0,theme/* spacing */.W0)("xl4"));
var StyledComments = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-3c1aca9a-3"
})(_templateObject3(), (0,theme/* container */.nC)("sm"), (0,theme/* spacing */.W0)("xl4"));
var StyledFloatingBannerContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3c1aca9a-4"
})(_templateObject4(), (0,theme/* container */.nC)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("mdMax"));
var StyledMainLayout = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3c1aca9a-5"
})(_templateObject5(), (0,theme/* spacing */.W0)("lg"), (0,theme/* container */.nC)("xl"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("md"));
var StyledHeaderWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3c1aca9a-6"
})(_templateObject6(), (0,theme/* container */.nC)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("lg"), (0,theme/* container */.nC)("xl"));
var INDEX_WIDTH = "300px";
var INDEX_THRESHOLD = "1450px";
var GAP = (0,theme/* spacing */.W0)("lg");
var StyledPostIndexWrapper = styled_components_browser_esm/* default.aside.withConfig */.ZP.aside.withConfig({
    componentId: "sc-3c1aca9a-7"
})(_templateObject7(), INDEX_THRESHOLD, INDEX_WIDTH, INDEX_WIDTH, INDEX_WIDTH, GAP);
var StyledPostIndexSticky = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3c1aca9a-8"
})(_templateObject8());
var StyledPostContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3c1aca9a-9"
})(_templateObject9(), (0,theme/* spacing */.W0)("md"));
var StyledRecommendedPosts = (0,styled_components_browser_esm/* default */.ZP)(RecommendedPosts).withConfig({
    componentId: "sc-3c1aca9a-10"
})(_templateObject10(), (0,theme/* container */.nC)("xl2"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xl3"));
var IndexToggleButton = (0,styled_components_browser_esm/* default */.ZP)(dist/* Button */.zx).withConfig({
    componentId: "sc-3c1aca9a-11"
})(_templateObject11(), function(param) {
    var $isOpen = param.$isOpen;
    return $isOpen ? "none" : "flex";
}, (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* radius */.q0)("xs"), INDEX_THRESHOLD);
var IndexDrawer = styled_components_browser_esm/* default.aside.withConfig */.ZP.aside.withConfig({
    componentId: "sc-3c1aca9a-12"
})(_templateObject13(), (0,theme/* spacing */.W0)("lg"), function(param) {
    var open = param.open;
    return open && (0,styled_components_browser_esm/* css */.iv)(_templateObject12());
}, INDEX_THRESHOLD);
var DrawerCloseButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-3c1aca9a-13"
})(_templateObject14(), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("sm"));
var IndexDrawerContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3c1aca9a-14"
})(_templateObject15(), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xxl"));
var DrawerOverlay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3c1aca9a-15"
})(_templateObject16());
var CTASection = (0,styled_components_browser_esm/* default */.ZP)(Cta/* default */.Z).withConfig({
    componentId: "sc-3c1aca9a-16"
})(_templateObject17(), (0,theme/* screen */.sp)("md"));

// EXTERNAL MODULE: ./utils/logos.ts
var logos = __webpack_require__(4335);
;// CONCATENATED MODULE: ./components/marketingSite/successStories/post/PostHeaderCard.styled.tsx

function PostHeaderCard_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: ",
        ";\n  gap: 0;\n  max-width: ",
        ";\n\n  @media (max-width: ",
        ") {\n    padding-bottom: 24px;\n  }\n"
    ]);
    PostHeaderCard_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PostHeaderCard_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: contents;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    PostHeaderCard_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PostHeaderCard_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.17;\n\n  grid-area: title;\n  color: #2d2d3a;\n  margin: ",
        " 0;\n  line-height: 1.15;\n  text-align: center;\n\n  @media (max-width: ",
        ") {\n    margin: 24px 0 16px 0;\n    font-size: 2rem;\n    line-height: 1.2;\n  }\n"
    ]);
    PostHeaderCard_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PostHeaderCard_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: thumb;\n  display: flex;\n  align-items: start;\n  justify-content: center;\n  overflow: hidden;\n  min-block-size: 0;\n  width: 100%;\n\n  img {\n    width: 100%;\n    height: auto;\n    object-fit: cover;\n    mask-image: url('/images/common/irregular-box-white.svg');\n    mask-size: 100% 100%;\n    mask-repeat: no-repeat;\n    mask-position: center;\n    -webkit-mask-image: url('/images/common/irregular-box-white.svg');\n    -webkit-mask-size: 100% 100%;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n  }\n\n  @media (max-width: ",
        ") {\n    justify-self: center;\n    margin-top: 24px;\n  }\n"
    ]);
    PostHeaderCard_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PostHeaderCard_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-weight: ",
        ";\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: underline;\n  }\n"
    ]);
    PostHeaderCard_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function PostHeaderCard_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: meta;\n  display: grid;\n  grid-template-areas: 'published';\n  grid-template-columns: max-content;\n  column-gap: 24px;\n  row-gap: 16px;\n  margin-top: 16px;\n  align-items: center;\n"
    ]);
    PostHeaderCard_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function PostHeaderCard_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n"
    ]);
    PostHeaderCard_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function PostHeaderCard_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  object-fit: cover;\n"
    ]);
    PostHeaderCard_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function PostHeaderCard_styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n"
    ]);
    PostHeaderCard_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function PostHeaderCard_styled_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 0.85rem;\n  font-weight: ",
        ";\n  color: #6b6b7b;\n  margin-bottom: 2px;\n  white-space: nowrap;\n"
    ]);
    PostHeaderCard_styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function PostHeaderCard_styled_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 0.95rem;\n  font-weight: ",
        ";\n  color: #2d2d3a;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    PostHeaderCard_styled_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function PostHeaderCard_styled_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: author;\n"
    ]);
    PostHeaderCard_styled_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function PostHeaderCard_styled_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: published;\n"
    ]);
    PostHeaderCard_styled_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function PostHeaderCard_styled_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: updated;\n"
    ]);
    PostHeaderCard_styled_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function PostHeaderCard_styled_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: readtime;\n"
    ]);
    PostHeaderCard_styled_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function PostHeaderCard_styled_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  margin-top: 16px;\n"
    ]);
    PostHeaderCard_styled_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function PostHeaderCard_styled_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: tags;\n  justify-self: center;\n  margin-bottom: 8px;\n"
    ]);
    PostHeaderCard_styled_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function PostHeaderCard_styled_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n"
    ]);
    PostHeaderCard_styled_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}


var StyledPostHeader = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-b152b2b1-0"
})(PostHeaderCard_styled_templateObject(), (0,theme/* spacing */.W0)("xl"), (0,theme/* container */.nC)("lg"), (0,theme/* screen */.sp)("lg"));
var StyledHeaderContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b152b2b1-1"
})(PostHeaderCard_styled_templateObject1());
var StyledHeaderTitle = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-b152b2b1-2"
})(PostHeaderCard_styled_templateObject2(), (0,theme/* fontFamily */.I8)("serif"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* fontSize */.JB)("xl5"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("lg"));
var StyledHeaderThumb = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b152b2b1-3"
})(PostHeaderCard_styled_templateObject3(), (0,theme/* screen */.sp)("lg"));
var StyledHeaderAuthorName = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-b152b2b1-4"
})(PostHeaderCard_styled_templateObject4(), (0,theme/* color */.$_)("emerald_600"), (0,theme/* fontWeight */.Ue)("semiBold"));
var StyledHeaderMetaTable = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b152b2b1-5"
})(PostHeaderCard_styled_templateObject5());
var MetaEntry = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b152b2b1-6"
})(PostHeaderCard_styled_templateObject6());
var MetaAvatar = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-b152b2b1-7"
})(PostHeaderCard_styled_templateObject7());
var MetaText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b152b2b1-8"
})(PostHeaderCard_styled_templateObject8());
var MetaTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-b152b2b1-9"
})(PostHeaderCard_styled_templateObject9(), (0,theme/* fontWeight */.Ue)("medium"));
var MetaValue = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-b152b2b1-10"
})(PostHeaderCard_styled_templateObject10(), (0,theme/* fontWeight */.Ue)("semiBold"));
var AuthorEntry = (0,styled_components_browser_esm/* default */.ZP)(MetaEntry).withConfig({
    componentId: "sc-b152b2b1-11"
})(PostHeaderCard_styled_templateObject11());
var PublishedEntry = (0,styled_components_browser_esm/* default */.ZP)(MetaEntry).withConfig({
    componentId: "sc-b152b2b1-12"
})(PostHeaderCard_styled_templateObject12());
var UpdatedEntry = (0,styled_components_browser_esm/* default */.ZP)(MetaEntry).withConfig({
    componentId: "sc-b152b2b1-13"
})(PostHeaderCard_styled_templateObject13());
var ReadTimeEntry = (0,styled_components_browser_esm/* default */.ZP)(MetaEntry).withConfig({
    componentId: "sc-b152b2b1-14"
})(PostHeaderCard_styled_templateObject14());
var StyledTagsAndShare = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b152b2b1-15"
})(PostHeaderCard_styled_templateObject15());
var StyledHeaderTags = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b152b2b1-16"
})(PostHeaderCard_styled_templateObject16());
var ShareButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b152b2b1-17"
})(PostHeaderCard_styled_templateObject17(), (0,theme/* container */.nC)("md"));

// EXTERNAL MODULE: ./utils/computeReadTime.ts
var computeReadTime = __webpack_require__(1999);
// EXTERNAL MODULE: ./components/shared/Badge.styled.tsx
var Badge_styled = __webpack_require__(71487);
;// CONCATENATED MODULE: ./components/marketingSite/successStories/cards/CategoryBadge.styled.tsx

function CategoryBadge_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  gap: ",
        ";\n"
    ]);
    CategoryBadge_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CategoryBadge_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 400;\n  border-width: 1px;\n  gap: ",
        ";\n\n  @media (max-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    CategoryBadge_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CategoryBadge_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 110%;\n  left: 0;\n  min-width: 120px;\n  background: #fff;\n  color: #222;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  padding: 8px 12px;\n  z-index: 3;\n  font-size: 0.95rem;\n  white-space: nowrap;\n"
    ]);
    CategoryBadge_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var StyledBadges = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a0e38fe6-0"
})(CategoryBadge_styled_templateObject(), (0,theme/* spacing */.W0)("xs"));
var StyledBadge = (0,styled_components_browser_esm/* default */.ZP)(Badge_styled/* default */.Z).withConfig({
    componentId: "sc-a0e38fe6-1"
})(CategoryBadge_styled_templateObject1(), (0,theme/* spacing */.W0)("xs"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xs2"));
var Popover = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a0e38fe6-2"
})(CategoryBadge_styled_templateObject2());

// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
;// CONCATENATED MODULE: ./components/marketingSite/successStories/cards/CategoryBadge.tsx




var CategoryBadge = function(param) {
    var _tagList = param.tagList, tagList = _tagList === void 0 ? [] : _tagList, _variant = param.variant, variant = _variant === void 0 ? "secondary" : _variant, _maxCategories = param.maxCategories, maxCategories = _maxCategories === void 0 ? 99 : _maxCategories;
    var visibleSubcategories = tagList.slice(0, Math.max(0, maxCategories));
    var remainingSubcategories = tagList.slice(visibleSubcategories.length);
    var ref = (0,react.useState)(false), showPopover = ref[0], setShowPopover = ref[1];
    var ref1 = (0,react.useState)({
        left: 0,
        top: 0
    }), popoverPos = ref1[0], setPopoverPos = ref1[1];
    var moreRef = (0,react.useRef)(null);
    var handleMouseEnter = function() {
        if (moreRef.current) {
            var rect = moreRef.current.getBoundingClientRect();
            setPopoverPos({
                left: rect.left,
                top: rect.bottom + 4
            });
            setShowPopover(true);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBadges, {
        children: [
            visibleSubcategories.map(function(category) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBadge, {
                    variant: variant,
                    children: category
                }, category);
            }),
            remainingSubcategories.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBadge, {
                ref: moreRef,
                variant: variant,
                onMouseEnter: handleMouseEnter,
                onMouseLeave: function() {
                    return setShowPopover(false);
                },
                style: {
                    position: "relative",
                    cursor: "pointer"
                },
                children: [
                    "...",
                    showPopover && /*#__PURE__*/ (0,react_dom.createPortal)(/*#__PURE__*/ (0,jsx_runtime.jsx)(Popover, {
                        style: {
                            position: "fixed",
                            left: popoverPos.left,
                            top: popoverPos.top,
                            zIndex: 9999
                        },
                        children: remainingSubcategories.map(function(cat) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: cat
                            }, cat);
                        })
                    }), document.body)
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/marketingSite/successStories/post/PostHeaderCard.tsx











var hiddenCategories = (/* unused pure expression or super */ null && ([
    "uncategorized",
    "uncategorised",
    "oculto",
    "sin-categorizar",
    "all",
    "todo-el-blog"
]));
function getPostAuthor(post) {
    var ref;
    var embedded = (ref = post._embedded) === null || ref === void 0 ? void 0 : ref.author;
    return embedded === null || embedded === void 0 ? void 0 : embedded[0];
}
function getPostThumb(post) {
    var ref, ref1;
    var media = (ref = post._embedded) === null || ref === void 0 ? void 0 : (ref1 = ref["wp:featuredmedia"]) === null || ref1 === void 0 ? void 0 : ref1[0];
    return media === null || media === void 0 ? void 0 : media.source_url;
}
var PostHeaderCard = function(param) {
    var post = param.post, sortedCategories = param.sortedCategories, onShareClick = param.onShareClick;
    var t = (0,useI18n/* useI18n */.Q)("success-stories").t;
    var locale = (0,router.useRouter)().locale;
    var author = getPostAuthor(post);
    var thumb = getPostThumb(post);
    var readDuration = (0,computeReadTime/* computeReadTime */.w)(post.content.rendered);
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPostHeader, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderThumb, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: thumb !== null && thumb !== void 0 ? thumb : logos/* LOGO_MANFRED_WHITE */.YM,
                    decoding: "async",
                    alt: "",
                    role: "presentation"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeaderContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderMetaTable, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PublishedEntry, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaText, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MetaValue, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: pro_light_svg_icons/* faCalendar */.fT7
                                        }),
                                        " ",
                                        new Date(post.date).toLocaleDateString(locale, {
                                            year: "numeric",
                                            month: "numeric",
                                            day: "numeric"
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderTitle, {
                        dangerouslySetInnerHTML: {
                            __html: post.title.rendered
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTagsAndShare, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderTags, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryBadge, {
                                    maxCategories: 7,
                                    tagList: (ref = (0,blogUtils/* getPostCategoriesId */.Em)(post, sortedCategories.parent)) !== null && ref !== void 0 ? ref : []
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareButton, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_styled/* default */.Z, {
                                    sizes: "sm",
                                    variant: "tertiary",
                                    onClick: onShareClick,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: pro_light_svg_icons/* faShare */.zBy
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: t("post.share")
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var post_PostHeaderCard = (PostHeaderCard);

;// CONCATENATED MODULE: ./components/marketingSite/successStories/post/PostIndex.styled.tsx

function PostIndex_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n\n  position: relative;\n  width: 100%;\n  max-width: 100%;\n  min-height: 220px;\n  box-sizing: border-box;\n  max-height: calc(100vh - 48px);\n\n  margin-bottom: 32px;\n  padding: ",
        " ",
        ";\n\n  font-size: 1.1rem;\n  background-image: url('/images/common/irregular-box-2.svg');\n  background-size: 100% 100%;\n  background-repeat: no-repeat;\n  background-position: top center;\n"
    ]);
    PostIndex_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PostIndex_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-y: auto;\n  flex: 1 1 auto;\n  gap: ",
        ";\n\n  .dash {\n    flex: 0 0 auto;\n    width: 18px;\n    font-weight: 400;\n    font-family: inherit;\n  }\n\n  ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    margin-bottom: ",
        ";\n\n    & > li {\n      display: flex;\n      align-items: flex-start;\n      gap: 8px;\n      margin-top: ",
        ";\n      color: ",
        ";\n\n      & > a {\n        text-decoration: none;\n        word-break: break-word;\n        line-height: 1.5;\n        font-size: 1.1rem;\n        color: ",
        ";\n      }\n    }\n  }\n"
    ]);
    PostIndex_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var StyledIndexBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b4c0e656-0"
})(PostIndex_styled_templateObject(), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl2"));
var StyledIndexContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b4c0e656-1"
})(PostIndex_styled_templateObject1(), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("sm"), (0,theme/* color */.$_)("emerald_750"), (0,theme/* color */.$_)("emerald_750"));

;// CONCATENATED MODULE: ./components/marketingSite/successStories/post/PostIndex.tsx



function extractH2(html) {
    var anchors = [];
    var h2Regex = /<h2\b([^>]*)>([\s\S]*?)<\/h2>/gi;
    var processedHtml = html.replace(h2Regex, function(_match) {
        var attrs = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", innerHTML = arguments.length > 2 ? arguments[2] : void 0;
        var textOnly = innerHTML.replace(/<[^>]+>/g, "").trim();
        var id = slugify(textOnly);
        anchors.push({
            headerLevel: 2,
            title: textOnly,
            id: id
        });
        var alreadyHasId = /\bid\s*=/.test(attrs);
        var newAttrs = alreadyHasId ? attrs : "".concat(attrs, ' id="').concat(id, '"');
        return "<h2".concat(newAttrs, ">").concat(innerHTML, "</h2>");
    });
    return {
        processedHtml: processedHtml,
        anchors: anchors
    };
}
function slugify(str) {
    return str.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9\s-]/g, "").trim().replace(/\s+/g, "-");
}
var PostIndex = function(param) {
    var post = param.post;
    var t = (0,useI18n/* useI18n */.Q)("success-stories").t;
    var anchors = extractH2(post.content.rendered).anchors;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIndexBox, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledIndexContent, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                    children: t("index.title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    children: anchors.map(function(param) {
                        var id = param.id, title = param.title;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "dash",
                                    children: "—"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "#".concat(id),
                                    children: title
                                })
                            ]
                        }, id);
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./utils/slugify.ts
var utils_slugify = __webpack_require__(95790);
// EXTERNAL MODULE: ../../node_modules/react-modal/lib/index.js
var lib = __webpack_require__(37149);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ./components/marketingSite/successStories/post/imageModal.tsx


var ImageModal = function(param) {
    var _isOpen = param.isOpen, isOpen = _isOpen === void 0 ? false : _isOpen, src = param.src, alt = param.alt, onClose = param.onClose;
    if (!src) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
        isOpen: isOpen,
        shouldCloseOnOverlayClick: true,
        onRequestClose: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "fixed inset-0 z-50 flex items-center justify-center",
            onClick: onClose,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute inset-0 bg-black/40 backdrop-blur-sm"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: src,
                    alt: alt,
                    className: "relative max-h-[90vh] max-w-[90vw] rounded-xl shadow-xl",
                    onClick: function(e) {
                        return e.stopPropagation();
                    }
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/shared/FormGroup.tsx
var FormGroup = __webpack_require__(74993);
// EXTERNAL MODULE: ./components/shared/InputText.tsx
var InputText = __webpack_require__(6776);
// EXTERNAL MODULE: ./components/shared/Modal.tsx
var Modal = __webpack_require__(61897);
// EXTERNAL MODULE: ./components/shared/ShareModal/ShareModal.styled.ts
var ShareModal_styled = __webpack_require__(80087);
// EXTERNAL MODULE: ./components/shared/TooltipMF.tsx
var TooltipMF = __webpack_require__(83885);
;// CONCATENATED MODULE: ./components/marketingSite/successStories/post/BlogShareModal.tsx









var BlogShareModal = function(param) {
    var shareModalIsOpen = param.shareModalIsOpen, shareModalClose = param.shareModalClose, slug = param.slug;
    var linkInputRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), copied = ref[0], setCopied = ref[1];
    var ref1 = (0,react.useState)(""), baseUrl = ref1[0], setBaseUrl = ref1[1];
    var t = (0,useI18n/* useI18n */.Q)("success-stories").t;
    (0,react.useEffect)(function() {
        setBaseUrl("".concat(window.location.origin));
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
            isOpen: shareModalIsOpen,
            contentLabel: t("share.title"),
            onAfterOpen: function() {
                setCopied(false);
            },
            shouldCloseOnOverlayClick: true,
            onRequestClose: shareModalClose,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                title: t("share.title"),
                onClose: shareModalClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormGroup/* default */.Z, {
                        label: t("share.label"),
                        forId: "shareLink",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputText/* default */.Z, {
                                id: "shareLink",
                                type: "text",
                                value: "".concat(baseUrl, "/successStories/").concat(slug),
                                title: slug,
                                variant: "copy",
                                readOnly: true,
                                ref: linkInputRef,
                                onClick: function() {
                                    var ref;
                                    (ref = linkInputRef.current) === null || ref === void 0 ? void 0 : ref.select();
                                    document.execCommand("copy");
                                    setCopied(true);
                                    setTimeout(function() {
                                        setCopied(false);
                                    }, 2000);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareModal_styled/* StyledCopyWrapper */.E$, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipMF/* default */.Z, {
                                    content: t("share.copied"),
                                    direction: "up",
                                    distance: 65,
                                    isOpen: copied,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareModal_styled/* StyledCopyAnchor */.ao, {})
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var post_BlogShareModal = (BlogShareModal);

;// CONCATENATED MODULE: ./components/marketingSite/successStories/layout/BlogRegisterCta.styled.tsx

function BlogRegisterCta_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: ",
        " auto;\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n  color: ",
        ";\n  background-image: ",
        ";\n  background-size: cover;\n  background-position: left 0;\n  background-repeat: no-repeat;\n\n  @media (max-width: ",
        ") {\n    background-size: unset;\n    background-position: left 5% bottom;\n    padding-top: ",
        ";\n    padding-bottom: ",
        ";\n    padding-left: 140px;\n    padding-right: ",
        ";\n  }\n\n  ",
        " {\n    margin-top: ",
        ";\n\n    @media (max-width: ",
        ") {\n      padding: ",
        ";\n      font-size: ",
        ";\n    }\n  }\n"
    ]);
    BlogRegisterCta_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BlogRegisterCta_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  text-transform: uppercase;\n  line-height: 1.2;\n  font-weight: ",
        ";\n  color: ",
        ";\n  margin-bottom: ",
        ";\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    text-transform: unset;\n  }\n"
    ]);
    BlogRegisterCta_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var BlogRegisterCta_styled_StyledCta = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-24e90f6-0"
})(BlogRegisterCta_styled_templateObject(), (0,theme/* container */.nC)("md"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* color */.$_)("indigo_900"), (0,theme/* radius */.q0)("lg"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xl8"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* color */.$_)("text_white"), function() {
    return "url('".concat((0,paths/* getPublicPath */.A)("/images/successStories/register-cta-bg.svg"), "')");
}, (0,theme/* screen */.sp)("mdMax"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xl"), ButtonLink_styled/* default */.C, (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("mdMax"), (0,theme/* spacing */.W0)("sm"), (0,theme/* fontSize */.JB)("xs"));
var StyledTitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-24e90f6-1"
})(BlogRegisterCta_styled_templateObject1(), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* color */.$_)("indigo_300"), (0,theme/* spacing */.W0)("xs"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("sm"));

;// CONCATENATED MODULE: ./components/marketingSite/successStories/layout/BlogRegisterCta.tsx











var BlogRegisterCta = function() {
    var t = (0,useI18n/* useI18n */.Q)("blog").t;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BlogRegisterCta_styled_StyledCta, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                children: t("registerCTA.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_styled/* Heading5 */.by, {
                as: "p",
                children: t("registerCTA.desc")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.join */.uu.join, locale), "?locale=").concat(locale, "&source=footer-blog"),
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink_styled/* default */.C, {
                    variant: "brandTalent",
                    sizes: "sm",
                    onClick: function(e) {
                        return service_event_tracking/* default.trackExternalLandingCtaClicked */.Z.trackExternalLandingCtaClicked(e, "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.join */.uu.join, locale), "?locale=").concat(locale, "&source=footer-blog"), "footer-blog");
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: free_solid_svg_icons/* faCheckCircle */.f8k
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: t("registerCTA.cta")
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var layout_BlogRegisterCta = (BlogRegisterCta);

;// CONCATENATED MODULE: ./components/marketingSite/successStories/post/PostComponent.tsx




















/* TODO: TEMPORAL helper. Investigate to use domutils, html-to-text, etc */ function nodeText(node) {
    var _data;
    if (node.type === "text") return (_data = node.data) !== null && _data !== void 0 ? _data : "";
    if (node.children) return node.children.map(nodeText).join("");
    return "";
}
var PostComponent = function(param) {
    var post = param.post, categories = param.categories, relatedPosts = param.relatedPosts, tags = param.tags;
    var closeImgModal = function closeImgModal() {
        setModalSrc(null);
    };
    var openShareModal = function openShareModal() {
        setIsOpen(true);
    };
    var closeShareModal = function closeShareModal() {
        setIsOpen(false);
    };
    var anchorsRef = (0,react.useRef)([]);
    var ref = (0,react.useState)(null), modalSrc = ref[0], setModalSrc = ref[1];
    var ref1 = (0,react.useState)(false), shareModalIsOpen = ref1[0], setIsOpen = ref1[1];
    var t = (0,useI18n/* useI18n */.Q)("success-stories").t;
    var locale = (0,router.useRouter)().locale;
    var ref2 = (0,react.useContext)(loggeduser_context/* LoggedUserContext */.Vi), user = ref2.user, loadingUser = ref2.loadingUser;
    var ref3 = (0,react.useState)(false), indexOpen = ref3[0], setIndexOpen = ref3[1];
    var ref4 = (0,react.useState)(false), drawerOpen = ref4[0], setDrawerOpen = ref4[1];
    var openDrawer = function() {
        return setDrawerOpen(true);
    };
    var closeDrawer = function() {
        return setDrawerOpen(false);
    };
    var postContent = (0,react.useMemo)(function() {
        anchorsRef.current = [];
        var options = {
            replace: function(domNode) {
                var ref;
                if (domNode.type === "tag") {
                    var ref1;
                    var el = domNode;
                    if (el.name === "h2") {
                        var text = nodeText(el).trim();
                        var id = (0,utils_slugify/* slugify */.l)(text);
                        el.attribs = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, el.attribs), {
                            id: id
                        });
                        anchorsRef.current.push({
                            headerLevel: 2,
                            title: text,
                            id: id
                        });
                    }
                    if (el.name === "img" && ((ref1 = el.attribs) === null || ref1 === void 0 ? void 0 : ref1.src)) {
                        var _attribs = el.attribs, src = _attribs.src, alt = _attribs.alt;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, el.attribs), {
                            style: {
                                cursor: "zoom-in"
                            },
                            onClick: function() {
                                return setModalSrc(src);
                            },
                            alt: alt
                        }));
                    }
                }
                // @ts-expect-error don't know why, but I cannot use `domNode instanceof Element`, as stated here: https://www.npmjs.com/package/html-react-parser#migration
                if (((ref = domNode.attribs) === null || ref === void 0 ? void 0 : ref.class) === "signup-banner") {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: !user && !loadingUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_BlogRegisterCta, {})
                    });
                }
            }
        };
        return (0,html_react_parser/* default */.ZP)(post.content.rendered, options);
    }, []);
    var sortedCategories = (0,react.useMemo)(function() {
        return (0,blogUtils/* sortCategories */.iH)(categories);
    }, [
        categories
    ]);
    (0,react.useEffect)(function() {
        console.log({
            relatedPosts: relatedPosts,
            tags: tags
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* default */.ZP, {
        hasScrollTop: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(post_PostHeaderCard, {
                            post: post,
                            sortedCategories: sortedCategories,
                            onShareClick: openShareModal
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMainLayout, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPostIndexWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPostIndexSticky, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostIndex, {
                                        post: post
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPostContentWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPostContent, {
                                    children: postContent
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecommendedPosts, {
                        relatedPosts: relatedPosts,
                        currentPost: post,
                        categories: categories,
                        locale: locale,
                        tags: tags
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Cta/* default */.Z, {
                        alt: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFloatingBannerContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_BlogFloatingCta, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageModal, {
                isOpen: Boolean(modalSrc),
                src: modalSrc,
                onClose: closeImgModal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(post_BlogShareModal, {
                slug: post.slug,
                shareModalIsOpen: shareModalIsOpen,
                shareModalClose: closeShareModal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IndexToggleButton, {
                $isOpen: drawerOpen,
                label: "",
                onClick: function() {
                    return drawerOpen ? closeDrawer() : openDrawer();
                },
                schema: "neutral",
                startIcon: pro_light_svg_icons/* faList */.Zrf
            }),
            drawerOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DrawerOverlay, {
                onClick: closeDrawer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(IndexDrawer, {
                    open: drawerOpen,
                    onClick: function(e) {
                        return e.stopPropagation();
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DrawerCloseButton, {
                            onClick: closeDrawer,
                            children: "\xd7"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IndexDrawerContent, {
                            onClick: closeDrawer,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostIndex, {
                                post: post
                            })
                        })
                    ]
                })
            }) : null
        ]
    });
};
/* harmony default export */ var post_PostComponent = (PostComponent);

// EXTERNAL MODULE: ./components/shared/HeadMetadataLangAlternate.tsx
var HeadMetadataLangAlternate = __webpack_require__(21646);
// EXTERNAL MODULE: ./context/slugs/slugs.context.tsx
var slugs_context = __webpack_require__(18694);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/next/script.js
var script = __webpack_require__(45847);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./pages/success-stories/[slug].tsx











var PostPage = function(props) {
    var t = (0,useI18n/* useI18n */.Q)("success-stories").t;
    var yoastHead = (0,html_react_parser/* default */.ZP)("".concat(props.post.yoast_head));
    var ref = (0,react.useContext)(slugs_context/* SlugsContext */.X), setSlug = ref.setSlug, clearSlug = ref.clearSlug;
    (0,react.useEffect)(function() {
        setSlug(props.post.language_slugs);
        return function() {
            clearSlug();
        };
    }, [
        props.post.id
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: yoastHead
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "successStoriesMetadata",
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: '{\n            "@context": "https://schema.org",\n            "@type": "Blog",\n            "name": "'.concat(t("pageTitle"), '",\n            "url": "https://www.getmanfred.com/blog",\n            "description": "').concat(t("pageDescription"), '",\n            "publisher": {\n              "@type": "Organization",\n              "name": "Manfred",\n              "logo": {\n                "@type": "ImageObject",\n                "url": "https://media-asgard.s3.eu-west-1.amazonaws.com/manfred-media/logo_manfred_color.svg?v=38732000",\n                "width": 200,\n                "height": 50\n              }\n            }\n          }')
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadMetadataLangAlternate/* default */.Z, {
                url: app_urls/* APP_URLS.successStories */.uu.successStories,
                path: {
                    ES: "".concat(props.post.slug),
                    EN: "".concat(props.post.slug)
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(post_PostComponent, (0,_object_spread/* default */.Z)({}, props))
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = (PostPage);


/***/ }),

/***/ 1999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ computeReadTime; }
/* harmony export */ });
/* harmony import */ var reading_time__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28618);
/* harmony import */ var reading_time__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(reading_time__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cleanup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27651);


function computeReadTime(html) {
    var text = (0,_cleanup__WEBPACK_IMPORTED_MODULE_1__/* .stripHtml */ .V)(html);
    return Math.round(reading_time__WEBPACK_IMPORTED_MODULE_0___default()(text).minutes);
}


/***/ }),

/***/ 95790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ slugify; }
/* harmony export */ });
var slugify = function(str) {
    return str.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^\w\s-]/g, "").trim().replace(/\s+/g, "-");
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7482,4115,8834,8618,625,4882,987,9774,2888,179], function() { return __webpack_exec__(30771); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);